var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00588F",
    d: "M3 0h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m15 6.085V6a1 1 0 0 0-1-1H3a1 1 0 0 0-.999.951l7.896 3.145a.25.25 0 0 0 .25 0zm0 1.587-7.105 2.724a1.75 1.75 0 0 1-1.745 0L2 7.55V14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1z"
  }))));
};
export default SvgEmail;